module.exports = __webpack_public_path__ + "img/myposition_am_지네딘 지단.c1cfffdb.png";